import { render, staticRenderFns } from "./CvSkills.vue?vue&type=template&id=b5d988a6&scoped=true"
import script from "./CvSkills.vue?vue&type=script&lang=js"
export * from "./CvSkills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d988a6",
  null
  
)

export default component.exports